// extracted by mini-css-extract-plugin
export default {"penalizedFilters":"hotelCardPenalizedFilters-module__penalizedFilters__XzncT","penalizedFiltersMobile":"hotelCardPenalizedFilters-module__penalizedFiltersMobile__W-UnP"};